import type { Device } from './types'
import generateFlags from './generateFlags'
import { defineNuxtPlugin, reactive, useRequestHeaders, useRuntimeConfig } from '#imports'

export default defineNuxtPlugin(() => {
  // const runtimeConfig = useRuntimeConfig()

  const runtimeConfig = {

    public : {
      device: {
        defaultUserAgent: 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_13_2) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/64.0.3282.39 Safari/537.36',
        enabled: true,
        refreshOnResize: true,
      }
    }
  }


  const defaultUserAgent = runtimeConfig.public.device.defaultUserAgent

  let flags: Device

  if (import.meta.server) {
    const headers = useRequestHeaders()

    const userAgent = headers['user-agent'] || defaultUserAgent

    flags = reactive(generateFlags(userAgent, headers))
  }
  else {
    const userAgent = navigator.userAgent || defaultUserAgent

    flags = reactive(generateFlags(userAgent))

    if (runtimeConfig.public.device.refreshOnResize) {
      window.addEventListener('resize', () => {
        setTimeout(() => {
          const newFlags = generateFlags(navigator.userAgent || userAgent)

          Object.entries(newFlags).forEach(([key, value]) => {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (flags as any)[key] = value
          })
        }, 50)
      })
    }
  }

  return {
    provide: {
      device: flags,
    },
  }
})
